export const UNIT_NUMBER_LENGTH_LIMIT = 20;
